<template>
  <page>
    <template slot="content">
      <q-and-a-content :title="'グループを作成する'">
        <template slot="content">
          <div class="text">ホームの左上をタップすると<b>メニュー</b>が表示されます。<b>グループを開設</b>をタップし必要な情報を入力するとグループが作成されます。</div>
          <img class="picture" src="../assets/images/features_admin/1.png">
        </template>
      </q-and-a-content>
    </template>
  </page>
</template>

<script>
  import Page from '@/components/Page'
  import QAndAContent from '@/components/QAndAContent.vue'

  export default {
    components: {
      Page,
      QAndAContent
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/FeaturesAdminCreateClub.vue